import { Helmet } from "react-helmet";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import SiteFooter from "../../components/layout/SiteFooter";
import StartFinderExperience from "./components/StartFinderExperience";

const Start = () => {
  return (
    <div className="relative">
      <Helmet>
        <title>Find the Right Utiva Programme in 3 Clicks</title>
        <meta
          name="description"
          content="Tell Utiva what excites you, where you are today and where you want to go—then get three practical programme recommendations."
        />
        <meta
          property="og:title"
          content="Find the Right Utiva Programme in 3 Clicks"
        />
        <meta
          property="og:description"
          content="A fast, intelligent course discovery experience from Utiva."
        />
      </Helmet>

      <header className="relative">
        <HeaderNavigation bgdark />
      </header>

      <StartFinderExperience />

      <SiteFooter />
    </div>
  );
};

export default Start;
